export default {
  REF_PAGE_NO_TRACKING: 'without_tracking',
  REF_PAGE_EMPTY_SEARCH: 'empty_search',
  REF_PAGE_EXPANDED_SEARCH: 'expanded_search',
  REF_PAGE_RESULT_PAGE_SEARCH: 'result_page_search',
}
